import { useState, useEffect } from 'react';
import axios from 'axios';
import AdminLayout from '@/components/AdminLayout';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Mail, MailOpen } from 'lucide-react';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await axios.get(`${API}/contact`);
      setMessages(response.data);
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axios.patch(`${API}/contact/${id}/read`);
      toast.success('Mesaj okundu olarak işaretlendi!');
      fetchMessages();
    } catch (error) {
      console.error('Error marking message as read:', error);
      toast.error('Bir hata oluştu!');
    }
  };

  return (
    <AdminLayout>
      <div>
        <h1 
          className="text-3xl font-bold text-gray-900 mb-8"
          style={{ fontFamily: 'Space Grotesk, sans-serif' }}
          data-testid="messages-title"
        >
          İletişim Mesajları
        </h1>

        <div className="space-y-4">
          {messages.map((message) => (
            <div 
              key={message.id} 
              className={`bg-white rounded-xl border p-6 ${
                message.read ? 'border-gray-200' : 'border-blue-200 bg-blue-50/30'
              }`}
              data-testid={`message-card-${message.id}`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  {message.read ? (
                    <MailOpen className="w-5 h-5 text-gray-400" />
                  ) : (
                    <Mail className="w-5 h-5 text-blue-600" />
                  )}
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">{message.name}</h3>
                    <p className="text-sm text-gray-600">{message.email} | {message.phone}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-500">
                    {format(new Date(message.created_at), 'dd MMM yyyy HH:mm', { locale: tr })}
                  </p>
                  {!message.read && (
                    <Button 
                      size="sm" 
                      variant="outline" 
                      className="mt-2"
                      onClick={() => markAsRead(message.id)}
                      data-testid={`mark-read-${message.id}`}
                    >
                      Okundu
                    </Button>
                  )}
                </div>
              </div>
              <div className="pl-8">
                <h4 className="font-medium text-gray-900 mb-2">{message.subject}</h4>
                <p className="text-gray-700">{message.message}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminMessages;